module.exports = __webpack_public_path__ + "static/media/pending-token.7789614e.svg";